<template>
  <div class="flex flex-col h-full">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-field="true"
        :show-filter="false"
        :show-footer="false"
      >
        <template #header>
          <div
            class="font-bold truncate flex items-center w-full pl-6"
            style="font-size: 17px; min-width: 250px"
          >
            Тарифы · {{ tarifList.length }}
          </div>
        </template>
        <template #field>
          <div class="flex flex-wrap items-center justify-end gap-3 p-4">
            <el-select
              v-model="filters.state"
              @change="getTarifList"
              placeholder="Статус"
              clearable
              style="max-width: 200px"
            >
              <el-option
                v-for="opt in stateOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
            <el-button @click="openForm" type="primary" plain
              >Добавить</el-button
            >
          </div>
        </template>
      </HeaderWrapper>
    </div>
    <main class="p-6 flex-1 min-h-0 flex flex-col overflow-hidden">
      <div class="flex-1 min-h-0 flex flex-col">
        <SkeletonView
          v-if="loading"
          :column="17"
          :row="12"
          size-table="large"
          style="height: 100%"
        />
        <el-table
          v-else
          border
          stripe
          class="h-full"
          height="100%"
          style="overflow-y: auto; height: 100%"
          :data="tarifList"
          @row-click="goToTariff"
        >
          <el-table-column
            prop="title"
            label="Название тарифа"
          ></el-table-column>
          <el-table-column prop="tariff" label="Тариф"></el-table-column>
          <el-table-column prop="type" label="Тип пользователя">
            <template v-slot="scope">
              {{ type[scope.row.type] }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="total > filters.limit"
          class="w-full flex items-center justify-center mt-3"
          background
          layout="pager"
          :total="total"
          :default-current-page="filters.page"
          :current-page="filters.page"
          @update:current-page="pageChange"
          :page-size="10"
        />
      </div>
    </main>
    <router-view @backWithUpdate="backWithUpdate" @getList="getTarifList" />
  </div>
</template>

<script>
import { getTarifList } from "@/api/tarif";
import HeaderWrapper from "@/components/HeaderWrapper.vue";
import SkeletonView from "@/components/skeleton/SkeletonView.vue";

export default {
  name: "tarif",
  components: {
    SkeletonView,
    HeaderWrapper,
  },
  data() {
    return {
      tarifList: [],
      loading: false,
      total: null,
      filters: {
        page: 1,
        limit: 10,
        state: 1,
      },
      type: {
        1: "Annontator",
        2: "Verifier",
      },
    };
  },
  computed: {
    stateOptions() {
      return [
        { label: "Активные", value: 1 },
        { label: "Неактивные", value: 0 },
        { label: "Удалённые", value: -1 },
      ];
    },
  },
  async created() {
    await this.getTarifList();
  },
  methods: {
    getParams() {
      let params = {};
      if (this.filters.page > 1) {
        params.page = this.filters.page;
      }
      params.limit = this.filters.limit;
      params.state = this.filters.state;
      return params;
    },
    async getTarifList() {
      this.loading = true;
      try {
        let params = this.getParams();
        let data = await getTarifList(params);
        this.tarifList = data.data;
        this.total = data.page.total_items;
      } catch (e) {
        this.tarifList = [];
        this.total = null;
      } finally {
        this.loading = false;
      }
    },
    pageChange(page) {
      this.filters.page = page;
      this.getTarifList();
    },
    goToTariff(row) {
      console.log(row._id);
      this.$router.push({ name: "tariff-item", params: { tarif_id: row._id } });
    },
    async openForm() {
      this.$router.push({ name: "tariff-item", params: { tarif_id: "new" } });
    },
    backWithUpdate(val) {
      this.filters.state = val;
      this.getTarifList();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
</style>
